<template>
  <div class="div-footer">
    <img class="footer-logo" src="@/assets/images/footer-logo.png" alt="">
    <ul class="font-li-01">
      <!--    <li>把本站设为首页</li>   -->
      <li>
<!--        <a @click="pushUri('https://service.scau.edu.cn/portal/taskcenter-v4/station_des.jsp')">本站申明</a>-->
<!--        <a  @click="pushUri('https://cloud.ketanyun.cn/workflow/bzsm')">本站申明</a>-->
<!--        <a  @click="$router.push({name:'bzsm'})">本站申明</a>-->
        <a  @click="bz()">本站申明</a>
      </li>
<!--      <form ref="form" v-show="false" action="http://service.scau.edu.cn/portal/mpti.ctl?pmn=getStaById&1693793227406" method="post">-->
<!--        <div>-->
<!--          <input name="sid" id="sid" value="1" />-->
<!--        </div>-->
<!--      </form>-->
      <!--    <li>-->
      <!--       <a @click="pushUri('http://estop.scau.edu.cn/portal/about_us.jsp')">关于大厅</a>-->
      <!--    </li>-->
      <li>
        <a @click="pushUri('https://service.scau.edu.cn/taskcenter/resources/scau/beta2/doc/help.pdf')">新手指南</a>
<!--        <a >新手指南</a>-->
      </li>
      <li>
<!--        <a @click="pushUri('http://estop.scau.edu.cn/portal/contact_us.jsp')">联系我们</a>-->
<!--        <a  @click="$router.push({name:'lxwm'})">联系我们</a>-->
<!--        <a >联系我们</a>-->
        <a  @click="lx()">联系我们</a>
      </li>
    </ul>
    <ul class="font-li-02" style="margin-top: -60px;">
<!--      <li>-->
<!--        <a @click="pushUri('http://service.scau.edu.cn/taskcenter/resources/scau/beta2/doc/%E5%B8%AE%E5%8A%A9%E6%96%87%E6%A1%A3.pdf')">新手指南</a>-->
<!--      </li>-->
      <!--      <li>-->
      <!--        <a @click="pushUri('http://estop.scau.edu.cn/portal/contact_us.jsp')">联系我们</a>-->
      <!--      </li>-->
      <!--      <li>-->
      <!--        <a @click="pushUri('http://estop.scau.edu.cn/admin/login.jsp')">管理入口</a>-->
      <!--      </li>-->
    </ul>
    <ul class="font-li-03">
      <span>推荐浏览器<br/>IE10以上浏览器、谷歌浏览器、搜狗高速浏览器、<br/>360浏览器极速版、UC浏览器<br/>以及其他甚于webkit内核的浏览器。</span>
    </ul>
    <ul class="font-li-04">
      <li>
        <span>总访问量：{{ totalCount }}</span>
        <span> 今日访问量：{{ todayCount }}</span>
      </li>
      <li>SCAU Copyright © 2023华南农业大学.All rights reserved.</li>
      <li>地址：广州市天河区五山路483号</li>
      <li>
        <span>粤1CP备05008874号</span>
        <span>备索编号：4401060500010</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'myFooter',
  data() {
    return {
      totalCount: '',
      todayCount: ''
    }
  },
  created() {
    this.getSelectMes();
  },
  methods: {
    getSelectMes() {
      this.$axios({
        method: "post",
        url: `${location.origin}/portal/mpti.ctl?pmn=getVisitCount&` + new Date().getTime()
      }).then(res => {
        if (res.data.result == 1) {
          this.totalCount = res.data.total_v;
          this.todayCount = res.data.today_v;
        }
      }).catch(error => {
        console.log(error)
      });

    },
    pushUri(val) {
      window.open(val);
    },
    bz(){
      window.open(`${window.commonApi.PATH}/workflow/bzsm`)
      // window.open(`https://service.scau.edu.cn/taskcenter-v4-new/workflow/bzsm`)
    },
    lx(){
      window.open(`${window.commonApi.PATH}/workflow/lxwm`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/myFooter.vue